import axios from 'axios';
import { Message } from 'element-ui';
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.baseURL = 'http://39.104.56.4:5000/';//生产环境
axios.defaults.withCredentials = true;
let instance = axios.create({});
instance.interceptors.request.use(
  config => {
    // const token = sessionStorage.getItem('token')
    // if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    //   config.headers.authorization = token  //请求头加上token
    // }
    return config
  },
  err => {
    return Promise.reject(err)
  }
);

instance.interceptors.response.use(
  response => {
    //拦截响应，做统一处理 
    if (response.data.code) {
      if (response.data.code != '000000') {
        Message({
          message: response.data.msg,
          type: 'error'
        });
      } else {
        // return Promise.reject()
      }
    }
    return response
  },
  //接口错误状态处理，也就是说无响应时的处理
  error => {
    return Promise.reject(error.response.status) // 返回接口返回的错误信息
  }
);

export default instance;